module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAVFBMVEVHcEz/hw/8ggv6gAv6gAr6gAr6gAr7gQz6gAr6gAr6gAr6gQz7gAr/qlX7gQr/jw/6gAv6gAr6gAr6jib93b3++fP8gAr////6gQv6gAr92bb92LXhsiCaAAAAGnRSTlMAEVyhv9nzUb77/zvFA5AQubrW////Xf+i8vwzfxMAAADQSURBVHgBjdRVYuQwEATQMgnKzHT/c+4mMdsa97wvMatx5vlBGCkVhYHvwU0by501Gk9xwpskxlWa0SFLcZIXdCrzU5uKH1R7q7TkR+U2Y8YX2bovvlr2mPBVgh+aAg3AUGAAz3JRN21T05GxHjqumr7vG2emw8BV+1PeOjMDQnmkEBGlNTGCokhhpGhERFGEkKIQAUUBOop8eJYC6x0XPPU3Mxfm9FTm/mbiQn/76OTn+/VHkL+U/Dl3eSl/czlgyKFHCmIOXjcs4XDoPJz8B0+bLgpUmfszAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/g1_icon_comments2_sel@2x.png
// module id = 38sG
// module chunks = 1